import React, { useState, useEffect, useContext } from 'react';
import HelpSiteService from "../SuperAdmin/Controller/Configuration/HelpSiteController";
import { ThemeContext } from "../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";

const HelpSite = ({ FormName, Module }) => {
  const [link, setLink] = useState('');
  const { theme } = useContext(ThemeContext);
  let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

  useEffect(() => {
    const fetchLink = async () => {
      try {
        const response = await HelpSiteService.GenerateHelpLink(Module, FormName);
        setLink(response[0].HelpSite); // Assuming the response contains the link
      } catch (error) {
        console.error('Error fetching the link:', error);
      }
    };

    fetchLink();
  }, [FormName, Module]);

  // Function to open the help page in a new window
  const openHelpWindow = () => {
    if (link) {
       const width = window.screen.width * 0.7;
       const height = window.screen.height * 0.7;
      
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      window.open(
        link.startsWith('http') ? link : `http://${link}`,
        'HelpWindow',
        `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`
      );
    }
  };

  return (
    <>
      {link ? (
        <Link
          onClick={(event) => {
            if (!link) {
              event.preventDefault();
              return;
            }
            openHelpWindow(event);
          }}
          className={`top-link ${!link ? 'disabled' : ''}`}
          style={{
            pointerEvents: !link ? 'none' : 'auto',
            opacity: !link ? 0.6 : 1,
            cursor: !link ? 'not-allowed' : 'pointer',
            float: "right"
          }}
        >
          <img
            src="assets/img/resources/help-icon.png"
            className="top-icon"
            alt="Help"

          />
          <strong className="top-text" style={{ fontSize: "10px" }}>
            {"Help".split(" ").map((word, i) => (
              <span key={i} className="top-word">
                {word}
              </span>
            ))}
          </strong>
        </Link>
      ) : (
        <Link
          className="top-link disabled"
          style={{
            pointerEvents: 'none',
            opacity: 0.6,
            cursor: 'not-allowed',
            float: "right"
          }}
        >
          <strong className="top-text" style={{ fontSize: "10px" }}>
            Link Not Entered
          </strong>
        </Link>
      )}
    </>
  );
};

export default HelpSite;
